<template>
	<div id="page">

		<!-- 页头 -->
		<pagehead />

		<!-- 公司详情 -->
		<el-container class="companyDetails w1k2 mauto mt40 mb35 bw br5">
			<el-header class="df aic">
				<div class="companyImg"><img class="img" src="../assets/company.png"></div>
				<div class="companyTxt ml15 c222 f28 b">{{tableData.entname}}</div>
			</el-header>
			<el-main>
				<div class="cDTable w100p">
					<!-- 基础字段 -->
					<div class="tr">
						<div class="td">YCODE</div>
						<div class="td">{{tableData.ycode}}</div>
						<div class="td">名 称</div>
						<div class="td">{{tableData.entname}}</div>
					</div>
					<div class="tr">
						<div class="td">省 市 区</div>
						<div class="td">{{tableData.proName}} {{tableData.cityName}} {{tableData.districtName}}</div>
						<div class="td">地 址</div>
						<div class="td">{{tableData.addr}}</div>
					</div>

					<!-- 非基础字段 -->
					<div :class="alert ? 'noBasics active' : 'noBasics'">
						<!-- 透明弹窗 -->
						<div class="nologin pa df dfc aic" v-if="alert">
							<div class="nologinTitle df aic">
								<div class="nologinTitleL"><img src="../assets/backslash.png"></div>
								<div class="nologinTitleM mlr10 f18 c2198f5">需要体验拓展字段请联系我们</div>
								<div class="nologinTitleR"><img src="../assets/backslash.png"></div>
							</div>
							<div class="nologinQr mt20 p5 tac bw"><img src="../assets/qr.png"></div>
							<div class="nologinTel mt15 c111 f16">电话：0531-88689279</div>
						</div>

						<div class="tr">
							<div class="td">状 态</div>
							<div class="td">{{tableData.recordStatusName}}</div>
							<div class="td">性 质</div>
							<div class="td">{{tableData.economicTypeName}}</div>
						</div>
						<div class="tr">
							<div class="td">机构类型</div>
							<div class="td">{{tableData.categoryName}}</div>
							<div class="td">信用码</div>
							<div class="td">{{tableData.creditCode}}</div>
						</div>
						<div class="tr">
							<div class="td">机构二级类型</div>
							<div class="td">{{tableData.categoryDetailedName}}</div>
							<div class="td">经纬度</div>
							<div class="td">
								{{tableData.lon? tableData.lon : ' ' + ' ' + tableData.lat? tableData.lat : ' '}}
							</div>
						</div>
						<div class="tr">
							<div class="th">非医疗机构字段</div>
						</div>
						<div class="tr">
							<div class="td">经营范围</div>
							<div class="td">{{tableData.scope}}</div>
							<div class="td">上级机构</div>
							<div class="td">{{tableData.parentName}}</div>
						</div>
						<div class="tr">
							<div class="td">药品经营许可证编号</div>
							<div class="td">{{tableData.drugLicense}}</div>
						</div>

						<div class="space" v-if="iforgan">
							<div class="tr">
								<div class="th">医疗机构字段</div>
							</div>
							<div class="tr">
								<div class="td">等 级</div>
								<div class="td">{{tableData.hospitalLevelName}}</div>
								<div class="td">级 别</div>
								<div class="td">{{tableData.hospitalGradeName}}</div>
							</div>
							<div class="tr">
								<div class="td">卫健委编码</div>
								<div class="td">{{tableData.medicalLicense}}</div>
							</div>
						</div>

					</div>


				</div>

				<!-- 返回 -->
				<div class="goBack df dfc aic w100p mt35">
					<el-button type="primary" @click="goBack">返回</el-button>
				</div>
			</el-main>
		</el-container>

		<!-- 页脚 -->
		<pagefoot />

	</div>
</template>
<script>
	// 全局变量
	var that;
	export default {
		// 页面变量
		data() {
			return {
				// 弹窗
				alert: false,
				// ycode
				ycode: null,
				// 表格数据
				tableData: {},
				// 是否是医疗机构
				iforgan: false,
			}
		},


		// 实例化后
		created() {

			that = this;

		},


		//	激活
		activated() {

			that.util.checkToken((res) => {

				// 判断是否游客
				if (localStorage.getItem('memberLevelId') == 5) {
					// 游客弹窗
					that.alert = true;
				};

				// 接受上个页面传递进来的参数
				that.ycode = that.$route.query.ycode;

				// 如果没有ycode
				if (!that.ycode) {
					that.alert("ycode不存在");
					// 返回页面
					that.$router.go(-1);
					return;
				}

				// 获取信息
				that.getInfo();

			})

		},


		// 方法集
		methods: {

			// 获取信息
			getInfo() {

				// 请求接口
				that.request({
					url: '/api/Organization/selectOrganizationListByYcode',
					data: {
						// YCOED
						ycode: that.ycode,
					},
					// 成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							// 赋值表格数据
							that.tableData = rs.data[0];

							// 区分医疗机构 判断是否等于
							if (that.tableData.category == '00710000' || that.tableData.category == '00720000') {

								that.iforgan = false;
							} else {

								that.iforgan = true;
							};

						} else {
							// 弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				});
			},

			// 返回
			goBack() {
				// 返回页码
				that.$router.go(-1);
			},
		},
	};
</script>
<style>
	/* 公司详情 */
	.companyDetails {
		box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, 0.13);
	}

	/* 公司详情头部 */
	.companyDetails header {
		padding: 30px;
		height: auto !important;
	}

	/* 公司详情头部图片 */
	.companyImg {
		width: 60px;
		height: 60px;
	}

	/* 表格 */
	.cDTable {
		border: 1px solid #EEEEEE;
	}

	/* 控制表格的显示或隐藏 */
	.cDTable .space {
		border-top: 1px solid #eee;
	}

	/* 每一格 */
	.cDTable .tr .td,
	.cDTable .tr .th {
		box-sizing: border-box;
		display: flex;
		align-items: center;
		min-height: 50px;
		padding: 15px 25px;
		/* padding: 0 25px; */
		font-size: 14px;
	}

	/* 第二格往后 */
	.cDTable .tr+.tr .td,
	.cDTable .tr+.tr .th {
		border-top: 1px solid #EEEEEE;
	}

	/* 每一行的第二个往后 */
	.cDTable .tr .td+.td {
		border-left: 1px solid #eee;
	}

	/* 非基础字段 */
	.noBasics {
		border-top: 1px solid #eee;
	}

	/* 非基础字段激活 */
	.noBasics.active {
		position: relative;
		user-select: none;
	}

	/* 非基础字段激活 */
	.noBasics.active .tr {
		filter: blur(2px);
	}

	/* 单元格2n */
	.cDTable .tr .td:nth-child(2n),
	.cDTable .tr .th {
		flex: 1;
	}

	/* 单元格2n-1 */
	.cDTable .tr .td:nth-child(2n-1) {
		box-sizing: border-box;
		width: 140px;
		background-color: #F6FAFF;
	}

	/* 返回按钮 */
	.goBack .el-button--primary {
		width: 130px;
		background-color: #0060DD;
		border-color: #0060DD;
	}

	/* 弹窗 */
	.nologin {
		width: 100%;
		height: 100%;
		background-image: linear-gradient(180deg, #CCE8FF 0%, rgba(249, 249, 249, 0) 100%);
		box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, 0.13);
		z-index: 1;
	}

	/* 弹窗标题 */
	.nologinTitle {
		margin-top: 80px;
	}

	.nologinTitleL,
	.nologinTitleR {
		width: 26px;
		height: 26px;
	}

	/* 弹窗二维码 */
	.nologinQr img {
		width: 80px;
		/* height: 80px; */
	}
</style>
